import React from 'react'
import { Dropdown, DropdownItem, DropdownMenuPosition } from '@duik/it'
import TableRow from '../UI/TableRow'
import EditIcon from '@material-ui/icons/BorderColorOutlined'
import MailIcon from '@material-ui/icons/MailOutlineOutlined'
import MoreIcon from '@material-ui/icons/MoreHoriz'
import ToolTip from '../UI/ToolTip'
import Avatar from '../UI/Avatar'
import { SingleItemNormal, ToolTipContainer, LeftSideColor } from '../UI/TableItem'

type Props = {
  item: {
    _id: string
    firstName: string
    lastName: string
    email: string
    phoneNumber: string
    company: string
    title: string
    delete: string
    companyId: string
  }
  contactDeleteModalToggle(_id: string): void
  editContactModalToggle(_id: string): void
  i: number
}
const ContactItem = (props: Props) => {
  const { item, contactDeleteModalToggle, editContactModalToggle, i } = props
  const color = LeftSideColor(i)

  const colors = ['color1', 'color2', 'color3', 'color4', 'color5', 'color6', 'color7', 'color8']
  return (
    <TableRow key={item._id}>
      <td style={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          content={`${item.firstName.charAt(0)}${item.lastName.charAt(0)}`}
          color={colors[color.index]}
        />
        <span>
          <span style={{ fontSize: '14px', fontWeight: 500 }}>
            {item.firstName} {item.lastName}
          </span>
          <br />
          <span style={{ fontSize: '12px', color: '#9EA0A5' }}>{item.title}</span>
        </span>
      </td>
      <SingleItemNormal text={item.company} />
      <SingleItemNormal text={item.email} />
      <SingleItemNormal
        text={`${item.phoneNumber.slice(0, 3)}-${item.phoneNumber.slice(3, 6)}-
        ${item.phoneNumber.slice(6, 10)}`}
      />
      <ToolTipContainer>
        <ToolTip title="Edit">
          <EditIcon onClick={() => editContactModalToggle(item._id)} className="actionsIcon" />
        </ToolTip>

        <ToolTip title="Email">
          <a href={`mailto:${item.email}`} target="_blank" rel="noopener noreferrer">
            <MailIcon className="actionsIcon" />
          </a>
        </ToolTip>
        <Dropdown
          ButtonComponent={(props: any) => (
            <MoreIcon className="actionsIcon" onClick={props.handleToggle} />
          )}
          menuPosition={DropdownMenuPosition['bottom-left']}
          closeOnOptionClick
        >
          <DropdownItem
            onClick={() => {
              contactDeleteModalToggle(item._id)
            }}
          >
            Delete
          </DropdownItem>
        </Dropdown>
      </ToolTipContainer>
    </TableRow>
  )
}

export default ContactItem
